import { FC } from 'react';
import { FaRegQuestionCircle } from '@react-icons/all-files/fa/FaRegQuestionCircle';

import { SlideoutBackButton, SlideoutCloseButton } from 'components/design-system/Slideout';
import { WatchItem } from 'components/seller/dashboard/WatchItem';
import { intercomShowNewMessage } from 'lib/intercom';
import { Listing } from 'types';

export const WatchHeaderTestIds = {
  container: 'watch-header-container',
  backButton: 'watch-header-back-button',
  intercomIcon: 'watch-header-back-intercom-icon',
  closeButton: 'watch-header-close-button'
};

export type WatchHeaderProps = {
  onClickPrevious?: () => void;
  onClose?: () => void;
  listing: Listing;
  isQuestionIconVisible?: boolean;
};

export const WatchHeader: FC<WatchHeaderProps> = ({
  onClickPrevious,
  listing,
  onClose,
  isQuestionIconVisible = true
}) => (
  <>
    <div
      data-testid={WatchHeaderTestIds.container}
      className='d-flex px-4 align-items-center w-100 position-relative'
      style={{ height: 89 }}
    >
      {onClickPrevious && (
        <SlideoutBackButton
          testID={WatchHeaderTestIds.backButton}
          className='position-static me-3'
          onClickPrevious={onClickPrevious}
        />
      )}
      <div className='d-flex justify-content-between flex-1 align-items-center'>
        <WatchItem
          titleClassName='text-primary'
          extraTitleInfo={listing.model.referenceNumber}
          textContentClassName='mx-1 fs-12px'
          listing={listing}
        />
        {isQuestionIconVisible && (
          <FaRegQuestionCircle
            data-testid={WatchHeaderTestIds.intercomIcon}
            role='button'
            style={{ minWidth: 24, minHeight: 24 }}
            onClick={intercomShowNewMessage}
            size={24}
          />
        )}
      </div>
      {onClose && (
        <SlideoutCloseButton
          testID={WatchHeaderTestIds.closeButton}
          className='position-static ms-3'
          onClick={onClose}
        />
      )}
    </div>
    <div className='mx-5 border-bottom' />
  </>
);
